// extracted by mini-css-extract-plugin
module.exports = {"module":"styles_module__2hfLM","playButton":"styles_playButton__2sz2m","description":"styles_description__2MX7z","meta":"styles_meta__2TfHj","icon":"styles_icon__Q-4ho"};